<script setup>
import categoryTree from '@/preload/data/categories.json'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:model-value'])
const navEntries = useAvailableCategoryTree(categoryTree)
const showDrawer = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:model-value', value)
  }
})
</script>

<template>
  <v-navigation-drawer
    v-model="showDrawer"
    :width="380"
    floating
    temporary
    class="mobile-navigation"
  >
    <v-sheet :height="100" class="pa-4 d-flex align-center position-relative">
      <cms-logo width="240" class="drawer-logo d-inline-block mr-6" />

      <v-btn
        icon="$close"
        variant="outlined"
        flat
        tile
        class="ml-auto"
        aria-label="Navigation schließen"
        @click="showDrawer = false"
      />
    </v-sheet>

    <v-divider class="mb-4" />

    <tree-view :items="navEntries" />
  </v-navigation-drawer>
</template>

<style lang="scss">
  .mobile-navigation {
    // above superchat-plugin and scrim
    z-index: 10006 !important;

    + .v-navigation-drawer__scrim {
      // above superchat-plugin, below drawer-content
      z-index: 10005;
    }

    .drawer-logo {
      max-width: 100%;

      img {
        max-height: 90px;
      }
    }

    .v-treeview-group {
      &.v-list-group--open {
        margin-bottom: 32px;
      }

      .v-list-group__header {
        .v-list-item-title {
          font-weight: 600;
        }
      }
    }
  }
</style>
